import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  InputBase,
  Paper,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Setting from "../../image/Setting.svg";
import Alert from "../../image/Alert.svg";
import "./Settings.css";
import MailIcon from "../MainIcons/MailIcon";
import SearchIcon from "@mui/icons-material/Search";
import CreateAccount from "../CreateUser/CreateAccount";
import Popup from "reactjs-popup";

import { Form, FormBuilder, Formio } from "@formio/react";
import Rolefile from "./Helpingfiles/Rolefile";
import ActiveOrNot from "./Helpingfiles/ActiveOrNot";
// import {Deleteuser,changerole} from "./Controller"

// import Newusercreate from './Newusercreate';
// import Rolefile from './Rolefile';
// import Dialogs from './Dialogs';

const Settings = (props) => {
  const [open, setOpen] = useState(false);
  const [userFixedData, setUserFixedData] = useState(null);
  const [usersdata, setusersdata] = useState(null);
  const Navigate = useNavigate();

  useEffect(() => {
    nextapicall();
  }, []);

  const nextapicall = async () => {
    let response = await fetch(
      `http://localhost:8080/auth/admin/realms/forms-flow-ai/users?briefRepresentation=true&first=0&max=50`,
      {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        Accept: "application/json",

        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          Host: "localhost:8080",
          "Sec-Fetch-Mode": "cors",
          "Sec-Fetch-Site": "same-site",

          //  "Remote Address": "[::1]:8080",

          Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url

        // body data type must match "Content-Type" header
      }
    );

    let data = await response.json();

    // setusersdata(data)
    setUserFixedData(data);
    setusersdata(data);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function logout() {
    // props.history.push('/');

    props.state.keycloak.logout();
  }

  function searchJson(jsonData, searchTerm) {
    let results = [];

    for (let i = 0; i < jsonData.length; i++) {
      let object = jsonData[i];
      for (let property in object) {
        if (object.hasOwnProperty(property)) {
          if (
            typeof object[property] === "string" &&
            object[property].includes(searchTerm)
          ) {
            results.push(object);
            break;
          }
        }
      }
    }

    setusersdata(results);
  }

  return (
    <div>
      <div className="EvidenceTaskNavbar">
        <div>
          <span className="EvidenceTitle">Users</span>
        </div>
        <div>
          <MailIcon state={props.state} />
        </div>
      </div>
      <div className="ManageAccessPage">
        <div className="ManageAccountUser">
          <h1 className="AudytUsers">Manage Access to your Audyt Users</h1>
          <p className="NewAudytparagraph">
            Add a new Audyt user using their email and assign them to a role.
          </p>
          <div>
            <Button
              variant="outlined"
              className="CreateNewUserbtn"
              onClick={handleClickOpen}
            >
              Create new user
            </Button>

            <Dialog open={open} onClose={handleClose} className="DialogBoxCSS">
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <CreateAccount setOpen={setOpen} />
                </DialogContentText>
              </DialogContent>
            </Dialog>
          </div>
        </div>
        <div className="numberofUsers">
          <h1 className="numUser">Number of users</h1>
          <h1 className="num">
            {usersdata ? usersdata.length : <div>Loading....</div>}
          </h1>
        </div>
      </div>
      <div className="Listofusers">
        <div className="Controlsearchbar">
          <span className="countnumberGroup">
            <span className="numCount">5/88</span> &nbsp;
            <span className="ControlsCounting"> Controls</span>
          </span>
          <Paper component="form" className="style">
            <IconButton type="button" id="IconSearch" aria-label="search">
              <SearchIcon />
            </IconButton>
            <InputBase
              id="SearchInput11"
              onChange={(e) => {
                e.preventDefault();

                searchJson(userFixedData, e.target.value);
              }}
              placeholder="Search..."
              inputProps={{ "aria-label": "Search..." }}
            />
          </Paper>
        </div>
        <div className="Listofusertable">
          <table className="SettingTable">
            <thead className="listoftablehead">
              <tr className="SettingPagetheadtr">
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody className="listoftablebody">
              {usersdata &&
                usersdata.map((data, index) => {
                  let linkto = `/userdetails/${data.id}`;

                  return (
                    <tr
                      onClick={() => {
                        Navigate(`/userdetails/${data.id}`);
                      }}
                      className="SettingPageTbodytr"
                    >
                      <td>
                        <span>
                          <Button
                            className="TableUserName"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {data.username.slice(0, 1)}
                          </Button>
                        </span>
                        {data.username}
                      </td>
                      <td>{data.email}</td>
                      <td>
                        <Rolefile id={data.id} />
                      </td>
                      <td className="ActiveState">
                        <ActiveOrNot userid={data.id} />
                      </td>
                      <td>
                        {new Date(data.createdTimestamp).toLocaleString()}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Settings;
